import Button from '@app/components/Button';
import { Colors } from '@app/config/colors';
import { PREDEFINED_QUERIES } from '@app/config/media-queries';
import { TextArea } from '@app/styles/forms';
import styled from 'styled-components';

export const FeedbackModalContent = styled.div`
  border-radius: 0px 0 3px 3px;
  background-color: #fff;
  height: 100%;
  overflow-y: auto;
  padding: 0 20px 20px 20px;

  @media screen and (${PREDEFINED_QUERIES.isMobile}) {
    padding-top: 20px;
  }
`;

export const FeedbackModalTitle = styled.h3`
  text-align: center;
  color: #333;
  margin-bottom: 5px;
`;

export const FeedbackModalDescription = styled.p`
  margin-bottom: 10px;
`;

export const FeedbackModalForm = styled.form``;

export const FeedbackModalMessageField = styled(TextArea)`
  width: 100%;
  height: 300px;
  margin: 5px 0;
`;

export const ButtonsRow = styled.div`
  display: flex;
  flex-direction: row;
  margin-bottom: 10px;

  & > *:not(:last-child) {
    margin-right: 5px;
  }
`;

export const FeedbackModalSubmitButton = styled(Button).attrs({
  type: 'submit',
})`
  flex: 1;
  background-color: ${Colors.Success};
`;

export const ButtonDelayControl = styled(Button)`
  background-color: #999;
  width: 50px;
  font-size: 16px;

  &:disabled {
    background-color: #ddd;
  }
`;

export const ButtonDelayControlLabel = styled.span`
  font-size: 20px !important;
`;

export const FeedbackModalWarningMessage = styled.span`
  color: #999;
  font-size: 12px;
`;
